import { render, staticRenderFns } from "./HomeHowItWorks.vue?vue&type=template&id=ca976290&scoped=true"
import script from "./HomeHowItWorks.vue?vue&type=script&lang=ts"
export * from "./HomeHowItWorks.vue?vue&type=script&lang=ts"
import style0 from "./HomeHowItWorks.vue?vue&type=style&index=0&id=ca976290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca976290",
  null
  
)

export default component.exports